import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

import TAGLink from '@/components/TAGLink';
import { AdFooterFooterPolicyGroupCollection, Maybe, NavigationLink, Page } from '@/types/generated';
import { resolveLinkTitle, resolveLinkUrl } from '@/components/FooterLite/FooterLite.helpers';
import { isOneTrustLink } from '@/components/Footer/Footer.helpers';
import { PrivacyOptions } from '@/assets/SVG';

import { policyLinkStyles, getPolicyGroupStyle } from './Footer.styles';

interface IFooterPolicyProps {
	policyGroup: Maybe<AdFooterFooterPolicyGroupCollection>;
}
const FooterPolicy = ({ policyGroup }: IFooterPolicyProps) => {
	const theme = useTheme();
	const isSmallDevice = useMediaQuery(theme.breakpoints.down('md'));

	const PolicyLinks = () => {
		const groupItems = policyGroup?.items;

		return (
			<Box data-testid="section_footer_policylinks" sx={getPolicyGroupStyle(isSmallDevice)}>
				{groupItems &&
					groupItems.map(
						(link: Maybe<NavigationLink | Page> | undefined, idx) =>
							link && (
								<TAGLink
									linkSx={{ display: 'flex' }}
									key={link.sys.id}
									href={resolveLinkUrl(link)}
									openInNewTab={(link as NavigationLink)?.openInNewTab || false}
									dataTestId={`policy_link_${link.sys.id}`}
									analyticsContext={link.analyticsContext}
									onClick={
										isOneTrustLink(link as NavigationLink)
											? (e) => {
													e.preventDefault();
													window?.OneTrust?.ToggleInfoDisplay();
											  }
											: undefined
									}
								>
									{isOneTrustLink(link as NavigationLink) && (
										<PrivacyOptions
											dataTestId={`privacy_icon_${link?.sys.id ?? idx}`}
											verticalAlign="middle"
										/>
									)}
									<Typography color="text.light" sx={policyLinkStyles} title={resolveLinkTitle(link)}>
										{resolveLinkTitle(link)}
									</Typography>
								</TAGLink>
							)
					)}
			</Box>
		);
	};
	return (
		<Box
			data-testid="section_footer_policy"
			flexDirection={{ xs: 'row', md: 'column' }}
			display={'flex'}
			width={{ xs: '100%', md: '40%' }}
			marginTop={{ xs: '1.5rem', md: '0px' }}
			justifyContent={'space-between'}
			gap={2}
		>
			<PolicyLinks />
		</Box>
	);
};

export default FooterPolicy;
